import initializeComponent from 'Shared/react-initialize';
import { ChakraDefaultProvider } from 'Shared/chakra-provider';
import { ComponentType, type JSX } from 'react';

export function Initializer<T extends JSX.IntrinsicAttributes>(Component: ComponentType<T>) {
   return (props: T) => (
      <ChakraDefaultProvider>
         <Component {...props} />
      </ChakraDefaultProvider>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
